export default "__VITE_ASSET__D3KVl1qe__"